import { render, staticRenderFns } from "./BotoxConfigurazioneDiagnosiListComponent.vue?vue&type=template&id=af140318"
import script from "./BotoxConfigurazioneDiagnosiListComponent.vue?vue&type=script&lang=js"
export * from "./BotoxConfigurazioneDiagnosiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports